import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
export const add_speciality = createAsyncThunk(
  "speciality/add_speciality",
  async ({ name, image }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("image", image);
      const { data } = await api.post("/add-speciality", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_speciality = createAsyncThunk(
  "speciality/get_speciality",
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/get-speciality?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_AllSpecialties = createAsyncThunk(
  "speciality/get_AllSpecialties",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get("/get-all-specialties", {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const specialityReducer = createSlice({
  name: "speciality",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    specialties: [],
    allSpecialties: [],
    totalSpeciality: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [add_speciality.pending]: (state, _) => {
      state.loader = true;
    },
    [add_speciality.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.error;
    },
    [add_speciality.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.specialties = [...state.specialties, payload.speciality];
    },
    [get_speciality.fulfilled]: (state, { payload }) => {
      state.totalSpeciality = payload.totalSpeciality;
      state.specialties = payload.specialties;
    },
    [get_AllSpecialties.fulfilled]: (state, { payload }) => {
      state.allSpecialties = payload.allSpecialties;
    },
  },
});
export const { messageClear } = specialityReducer.actions;
export default specialityReducer.reducer;
